import { createContext, useContext } from 'react'

export const PageBannerContext = createContext(false)

export const useIsInPageBanner = () => useContext(PageBannerContext)
